import { useState } from 'react';
import Resizer from 'react-image-file-resizer';
import UnifiedDatePicker from '../../components/Calendario';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment-timezone';

const PaqueteForm = ({ viviendas }) => {
	const [fechaLlegada, setFechaLlegada] = useState(null);
	const [id_vivienda, setVivienda] = useState(0);
	const [foto_paquete_url, setfoto_paquete_url] = useState(null);

	async function changePaqueteImagen(event) {
		let file = event.target;
		if (file) {
			if (file.files[0]) {

				const maxWidth = 1024;
				const maxHeight = 640;
				const quality = 85;

				Resizer.imageFileResizer(
					file.files[0],
					maxWidth,
					maxHeight,
					'JPEG',
					quality,
					0,
					uri => {
						setfoto_paquete_url(uri);
					},
					'base64'
				);
			}
		}
	}

	return (
		<div className="tw-grid tw-grid-cols-[3fr_1fr] tw-w-full tw-items-center tw-gap-5">
			<div className="tw-w-full tw-space-y-1.5 tw-text-xs">
				<div className="tw-flex tw-flex-col">
					<label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Vivienda:</label>
	    			<select
						id="paquete-id_vivienda"
						name="paquete-id_vivienda"
						value={id_vivienda}
						onChange={(e) => setVivienda(Number(e.target.value))}
						className="input-edit-sm tw-text-left"
						required
					>
						<option value="">Selecciona una vivienda</option>

						{viviendas.map((vivienda) => (
							<option
								key={vivienda.id_vivienda}
								value={vivienda.id_vivienda}
							>
								{vivienda.numero_registro}
							</option>
						))}
					</select>
				</div>
				<div className="tw-flex tw-flex-col">
                    <label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Paquetería:</label>
					<input
						className="input-edit-sm tw-text-left"
						type="text"
						name="paquete_empresa"
						id="paquete_empresa"
						autoComplete='off'
						required
					/>
				</div>
				<div className="tw-flex tw-flex-col">
					<label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Destinatario:</label>
					<input
						className="input-edit-sm tw-text-left"
						type="text"
						name="paquete_nombre_residente"
						id="paquete_nombre_residente"
						autoComplete='off'
						required
					/>
				</div>
				<div className="tw-flex tw-flex-col">
					<label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Fecha llegada:</label>
					<div className="tw-flex tw-flex-col">
						<UnifiedDatePicker
    						selected={fechaLlegada}
    						onChange={(date) => {
        						setFechaLlegada(date);
    						}}
    						includeTime={true}
    						dateFormat="dd/MM/yyyy HH:mm"
    						maxDate={new Date()}
    						placeholderText="DD/MM/YYYY HH:mm"
    						className="input-edit-sm tw-text-left tw-w-full"
							required
						/>
						<input
							id="paquete_fecha_llegada"
							name="paquete_fecha_llegada"
							type="hidden"
							value={fechaLlegada ? moment(fechaLlegada).format("YYYY-MM-DDTHH:mm") : ""}
						/>
					</div>
				</div>
				<div className="tw-flex tw-flex-col">
					<label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Comentarios:</label>
					<div className="tw-flex tw-flex-col">
						<textarea
							id="paquete_comentarios"
							name="comentarios"
							cols="30"
							rows="3"
							maxLength="500"
							className="input-edit-sm tw-text-left tw-w-full tw-h-20"
						>
						</textarea>
					</div>
				</div>
			</div>
			<div className="tw-flex tw-flex-col tw-self-start tw-items-center tw-justify-center">
				<div className="tw-relative tw-w-47 tw-h-44 tw-overflow-hidden tw-rounded tw-shadow">
					<img
						src={foto_paquete_url || require('../../img/empty_image.png')}
						alt="Preview paquete"
						className="tw-w-full tw-h-full tw-object-contain"
						id="previewArea"
					/>

					<label
						htmlFor="paquete_foto_llegada"
						className="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-50 tw-text-white tw-cursor-pointer tw-opacity-0 hover:tw-opacity-100 tw-transition tw-text-xs"
					>
						<i className="fas fa-file-upload tw-mb-1 tw-text-3xl"></i>

						<input
							type="file"
							id="paquete_foto_llegada"
							name="paquete_foto_llegada"
							accept="image/*"
							onChange={changePaqueteImagen}
							className="tw-hidden"
						/>

						<span>Subir imagen</span>
					</label>
				</div>
			</div>
		</div>
	)
}

export default PaqueteForm;
